import React from 'react';
import PropTypes from 'prop-types';

import ArrowLeft from './ArrowLeft';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const ArrowRight = ({ color = '#B5BCBD', size = 20, ...props }) => (
  <ArrowLeft
    color={color}
    size={size}
    {...props}
    style={{
      transform: 'rotate(180deg)',
    }}
  />
);

ArrowRight.propTypes = propTypes;

export default ArrowRight;
